import HasID from "@/models/HasID";
import HasLabel from "@/models/HasLabel";
import { AcceptanceSource } from "@/models/AcceptanceSource";

export interface AcceptanceRecord extends HasID {
    // Do not set this.
    id: number;
    configurationId: number;
    patientId: number;
    // Do not set this.  We cannot save a signature for the patient through cphub frontend.
    signatureData?: string;
    orderId?: number;
    // Do not set this. This is done on db save.
    created: Date;
    // Do not set this. This is done on db save.
    createdBy: string;
    endDate: Date;
    declined: boolean;
    imageId?: number;
    sourceType: AcceptanceSource;
}

export class AcceptanceRecord extends HasLabel {
    constructor(obj?: AcceptanceRecord) {
        super();
        if (obj) {
            Object.assign(this, obj);
            // Ensure sourceType has a default value for backward compatibility
            if (this.sourceType === undefined) {
                this.sourceType = AcceptanceSource.Electronic;
            }
        }
    }

    toString(): string {
        if (!this.id) return "";
        return `${this.id} - ${this.signatureData}`;
    }
}
